import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const items = t('home.faqSection.items', { returnObjects: true }) as FaqItem[];

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            {t('home.faqSection.title')}
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={index} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900">{item.q}</span>
                  <i className={`ri-add-line text-lg text-foreground-500 transition-transform ${isOpen ? 'rotate-45' : ''}`}></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}